import PropTypes from 'prop-types'
import React from 'react'

import { Text, H2 } from 'styles/components/typography'

import FullSizeVideoBlockMobile from './components/FullSizeVideoBlockMobile'
import {
  StyledSectionWrapper,
  StyledYouTubePlayerMd,
  StyledIcon,
} from './styles'

/**
 * FullSizeVideoBlock
 *
 * @param {object} props - properties of component
 * @returns {node} FullSizeVideoBlock
 */
const FullSizeVideoBlock = ({ data, isMobile, cover, isTextInnerOnMobile }) => {
  if (isMobile) {
    return (
      <FullSizeVideoBlockMobile {...{ data, cover, isTextInnerOnMobile }} />
    )
  }

  return (
    <StyledSectionWrapper
      isOverflowHidden={true}
      beforeElement={
        <StyledYouTubePlayerMd videoId={data.media.id} cover={cover} />
      }
    >
      <div className="row h-100 align-items-center">
        <div className="col-12 col-md-6 offset-md-6 col-lg-7 text-white">
          <H2 dangerouslySetInnerHTML={{ __html: data.title }} />
          <Text
            className="max-w--450"
            dangerouslySetInnerHTML={{ __html: data.content }}
          />
          {data.icon && <StyledIcon id={data.icon} />}
        </div>
      </div>
    </StyledSectionWrapper>
  )
}

FullSizeVideoBlock.propTypes = {
  data: PropTypes.object.isRequired,
  cover: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  isTextInnerOnMobile: PropTypes.bool,
}

FullSizeVideoBlock.defaultProps = {
  isMobile: false,
  isTextInnerOnMobile: false,
}

export default FullSizeVideoBlock
